export default {
	name: 'partnersSection',
	title: 'Partners Section',
	type: 'object',
	fields: [
		{
			name: 'title',
			title: 'Section Title',
			type: 'string',
		},
		{
			name: 'subtitle',
			title: 'Section Subtitle',
			type: 'text',
		},
		{
			name: 'partners',
			title: 'Partners',
			type: 'array',
			of: [
				{
					type: 'partner',
				},
			],
		},
	],
};
